import gql from "graphql-tag";
const UPDATE_MAS_FROM_IMDBID = gql `
  mutation updateMASFromImdbId($imdbId: String!) {
    updateMASFromImdbId(imdbId: $imdbId) {
      id
    }
  }
`;
export default UPDATE_MAS_FROM_IMDBID;
